import { Component, Input, OnInit } from '@angular/core';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';

@Component({
  selector: 'app-LetterRequestCustomerPeyvast',
  templateUrl: './LetterRequestCustomerPeyvast.component.html',
  styleUrls: ['./LetterRequestCustomerPeyvast.component.scss']
})
export class LetterRequestCustomerPeyvastComponent implements OnInit {

  @Input() canOpenPeyvast:boolean=false;
  constructor() { }

  @Input() DataList_Peyvast:Array<LetterRequestCustomer_List_Interface>=[]

  ngOnInit() {
    console.log(this.canOpenPeyvast);
    
  }
}
